import { Text } from 'native-base';
import React, { useLayoutEffect } from 'react';

import LocaleRadio from 'app/components/LocaleRadio';
import Screen from 'app/components/Screen';
import { RootScreenProps, RootStackParamList } from 'app/navigation/RootNavigator';
import { useI18n } from 'app/providers/I18nProvider';
import { tID } from 'app/services/TestHelper';

export type LanguageScreenProps = RootScreenProps<RootStackParamList, 'Language'>;

export default function LanguageScreen({ navigation, route }: LanguageScreenProps) {
  const { t } = useI18n();

  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => (
        <Text testID={tID('LanguagePickerHeading')}>{t('app_menu_language')}</Text>
      ),
    });
  }, [navigation, t]);

  return (
    <Screen testID={tID('LanguageScreen')}>
      <LocaleRadio />
    </Screen>
  );
}
